var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormatHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 11.316,
    viewBox: "0 0 19 11.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2208",
    "data-name": "Rettangolo 2208",
    width: 10.317,
    height: 18,
    transform: "translate(18.5 0.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatHorizontal);
export default __webpack_public_path__ + "static/media/format-horizontal.d5e4948c7708119b0cf5196cd815a7f3.svg";
export { ForwardRef as ReactComponent };